import Header from '../header/Header';
import './checkout.scss';
import { useNavigate } from 'react-router-dom';

const Checkout = () => {
    let navigate = useNavigate();

    let goback = () => {
        navigate('/');
    };

    return (
        <>
            <Header />
            <div className="checkout_parent">
                <div className="checkout_child">
                    <h1>THANK YOU</h1>
                    <div>
                        <span>Your order has been Placed sucessfully.</span>
                        <ion-icon style={{ color: '#01a001' }} name="checkmark-circle-sharp"></ion-icon>
                    </div>

                    <div className="checkout_homelink" onClick={goback}>Click here to continue shopping</div>
                </div>
            </div>
        </>
    )
}

export default Checkout;